import React, { useEffect, useState } from 'react'
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import logo from "../../Assets/Images/Logo.avif";
import { Link, Links } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';

const Header = () => {

    const [isScrolled, setIsScrolled] = useState(false)
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 2) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };
        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const [expanded, setExpanded] = useState(false);

    const handleLinkClick = () => {
        setExpanded(false); // closes the navbar
    };


    return (
        <>
            <header
                className={`${!isScrolled
                    ? "header-three header-absolute sticky-header"
                    : "header-absolute header-three sticky-header sticky bg-white"
                    }     d-xl-block d-none`}
            >

                <Navbar expand="lg" className="">
                    <Container>
                        <Navbar.Brand as={Link} to="/">
                            <img src={logo} alt="" width={130} />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">
                            <Nav
                                className="me-auto my-2 my-lg-0"
                                style={{ maxHeight: '100px' }}
                                navbarScroll
                            >

                            </Nav>
                            <Nav.Link className='fw-bold' as={Link} to={"/login"}><FaUser className='me-2' size={16} />
                                Login/Register</Nav.Link>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>

            <header className="d-xl-none d-block">
                <Navbar expand="lg" expanded={expanded} onToggle={setExpanded}>
                    <Container>
                        <Navbar.Brand as={Link} to="/" onClick={handleLinkClick}>
                            <img src={logo} alt="" width={130} />
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="navbarScroll" />
                        <Navbar.Collapse id="navbarScroll">

                            <Nav.Link
                                className='fw-bold'
                                as={Link}
                                to="/login"
                                onClick={handleLinkClick}
                            >
                                <FaUser className='me-2' size={16} />
                                Login/Register
                            </Nav.Link>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </header>

        </>
    )
}

export default Header